import { InjectionToken, Provider } from '@angular/core';
import { ActionReducer, ActionReducerMap, MetaReducer, combineReducers } from '@ngrx/store';
import { LoginLogoutActionTypes } from '../../../../core/auth/user-auth/store/actions/login-logout.action';
import { AreaOfUse } from '../../../../core/model';
import { CurrenciesActionTypes } from '../../../../core/site-context/store/actions/currencies.action';
import { LanguagesActionTypes } from '../../../../core/site-context/store/actions/languages.action';
import { PyStateUtils } from '../../../../core/state';
import { SoldToActions } from '../../../sold-to-base/store/actions';
import {
  AREAS_OF_USE_PUBLISH_ADMIN,
  AREA_OF_USE_CATEGORY_ADMIN,
  AREA_OF_USE_CATEGORY_DETAILS,
  AREA_OF_USE_LIST_ADMIN,
  AREA_OF_USE_PRODUCTS,
  AREA_OF_USE_PRODUCTS_ADD,
  AREA_OF_USE_PRODUCTS_REMOVE,
  AREA_OF_USE_PRODUCTS_REPLACE,
  AreaOfUseAdminListState,
  AreaOfUseAdminState,
} from '../area-of-use-admin-state';
import { areaOfUseAdminCategoriesReducer, areaOfUseAdminListReducer } from './area-of-use-admin.reducer';

export function getReducers(): ActionReducerMap<AreaOfUseAdminState, any> {
  return {
    categories: PyStateUtils.entityLoaderReducer<AreaOfUse>(AREA_OF_USE_CATEGORY_ADMIN, areaOfUseAdminCategoriesReducer),
    list: PyStateUtils.loaderReducer<AreaOfUseAdminListState>(AREA_OF_USE_LIST_ADMIN, areaOfUseAdminListReducer),
    details: PyStateUtils.loaderReducer<AreaOfUse>(AREA_OF_USE_CATEGORY_DETAILS),
    products: combineReducers({
      list: PyStateUtils.loaderReducer<AreaOfUse[]>(AREA_OF_USE_PRODUCTS),
      add: PyStateUtils.loaderReducer<AreaOfUse>(AREA_OF_USE_PRODUCTS_ADD),
      remove: PyStateUtils.loaderReducer<AreaOfUse>(AREA_OF_USE_PRODUCTS_REMOVE),
      replace: PyStateUtils.loaderReducer<AreaOfUse>(AREA_OF_USE_PRODUCTS_REPLACE),
    }),
    publish: PyStateUtils.loaderReducer<string>(AREAS_OF_USE_PUBLISH_ADMIN),
  };
}

export const reducerToken = new InjectionToken<ActionReducerMap<AreaOfUseAdminState>>('AreaOfUseAdminReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};

export function clearAreaofUseAdminState(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action) {
    if (action.type === LoginLogoutActionTypes.Logout) {
      state = undefined;
    }
    if (action.type === CurrenciesActionTypes.CurrencyChange || action.type === LanguagesActionTypes.LanguageChange) {
      state = undefined;
    }

    return reducer(state, action);
  };
}

export function clearStateOnContextChange(reducer: ActionReducer<any>, transformer?: (state: any) => any): ActionReducer<any> {
  return function (state, action) {
    if (action.type === SoldToActions.ChangeSoldToActionTypes.ChangeSoldToSuccess) {
      state = transformer ? transformer(state) : undefined;
    }
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<any>[] = [clearAreaofUseAdminState];
